exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wabident-treatment-icon{display:inline-flex;justify-content:center;align-items:center}.wabident-treatment-icon i{color:inherit;font-size:inherit}", ""]);

// exports
